import React from 'react'
import { useSelector } from 'react-redux'
import FavoriteIcon from '@material-ui/icons/Favorite'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
import {
  faCarSide,
  faTruck,
  faTruckPickup,
  faVanShuttle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import {
  addParkingLotToFavorite,
  closeSearchBarToggle,
  fetchParkingLotData,
  fetchParkingLotFavorites,
  removeParkingLotFromFavorite,
  setActiveLotId,
  setDestination,
  setMarkerInfo,
  setSelectedFavoritedParkingLots,
  setSelectedParkingLots,
  setZoom,
  updateBottomSheet,
} from '../../../../sections/Map/redux/myMapsSlice'
import {
  EmptyComponent,
  setPolylineStyle,
  sortListAlphabetically,
  sortParkingListAlphabetically,
} from '../../../../utils/helpers'
import { stopsListComponentStyles } from '../../../List/StopsListComponent/stopsListComponentStyles'
import { storeFavoriteParkingLotListToFirebase } from '../../../../../apps/helpers'
import {
  CAM,
  CAMDEN_COLOR,
  MOBILEPARKINGINFOWINDOW,
  NB,
  NEW_BRUNSWICK_COLOR,
  NEWARK_COLOR,
  NWK,
  OTHER_COLOR,
} from '../../../../utils/constants'

function ParkingList({ dispatch, classes }) {
  const isDesktopView = useMediaQuery((theme) => theme.breakpoints.up('md'))
  const [loading, setLoading] = React.useState(true)
  const {
    parkingLotData,
    fetchParkingLotDataLoading,
    favoritedParkingLotsLoading,
    selectedParkingLots,
    selectedFavoritedParkingLots,
  } = useSelector((s) => s.maps)

  React.useEffect(() => {
    dispatch(fetchParkingLotData())
    dispatch(fetchParkingLotFavorites())
  }, [])

  const setSheetData = () => {
    dispatch(
      setSelectedParkingLots(
        sortParkingListAlphabetically(
          parkingLotData.filter((el) => ![].includes(el)),
        ),
      ),
    )
  }

  React.useEffect(() => {
    if (
      fetchParkingLotDataLoading === 'fulfilled' &&
      favoritedParkingLotsLoading === 'fulfilled'
    ) {
      setSheetData()
      setLoading(false)
    } else {
      setLoading(true)
    }
  }, [fetchParkingLotDataLoading, favoritedParkingLotsLoading])

  return (
    <div className={classes.outerList}>
      {loading ? (
        <></>
      ) : (
        <>
          {selectedParkingLots.length > 0 && (
            <List className={classes.list}>
              {selectedFavoritedParkingLots.length > 0 && (
                <li className={classes.newListSection}>
                  <ul className={classes.newUl}>
                    <ListSubheader className={classes.listSubHeader}>
                      Favorited Parking Lots
                    </ListSubheader>
                    {selectedFavoritedParkingLots.map((lot, index) => (
                      <ParkingListComponent
                        isDesktopView={isDesktopView}
                        lot={lot}
                        dispatch={dispatch}
                        key={`${lot.mapId}`}
                        index={index}
                        isFavorited={selectedFavoritedParkingLots.some(
                          (s) => s.route_id === lot.stop_id,
                        )}
                      />
                    ))}
                  </ul>
                </li>
              )}

              <li key="section-parkinglots" className={classes.newListSection}>
                <ul className={classes.newUl}>
                  <ListSubheader className={classes.listSubHeader}>
                    Parking Lots
                  </ListSubheader>
                  {selectedParkingLots.map((lot, index) => (
                    <ParkingListComponent
                      isDesktopView={isDesktopView}
                      lot={lot}
                      dispatch={dispatch}
                      key={`${lot.mapId}`}
                      index={index}
                      isFavorited={selectedFavoritedParkingLots.some(
                        (s) => s.route_id === lot.stop_id,
                      )}
                    />
                  ))}
                </ul>
              </li>
            </List>
          )}
          {selectedParkingLots.length === 0 && (
            <div className={classes.list}>
              <EmptyComponent />
            </div>
          )}
        </>
      )}
    </div>
  )
}

const ParkingListComponent = ({
  isDesktopView,
  lot,
  isFavorited,
  dispatch,
}) => {
  const classes = stopsListComponentStyles()
  const {
    map,
    favoritedParkingLots,
    parkingLotData,
    datasetLayer,
    lotId,
    filters,
  } = useSelector((s) => s.maps)
  const [favorited, setFavorited] = React.useState(isFavorited)
  const isGuest =
    localStorage.getItem('user') === '"visitor"' ||
    localStorage.getItem('user') === ''
  React.useEffect(() => {
    // default favorited lots
    const isFavoritedFound = favoritedParkingLots?.find(
      (favoritedParkingLot) => favoritedParkingLot.mapId === lot.mapId,
    )
    if (isFavoritedFound) {
      setFavorited(true)
    } else {
      setFavorited(false)
    }
  }, [parkingLotData, favoritedParkingLots])

  const viewParkingLotInfo = () => {
    map.panTo({
      lat: lot.location.lat,
      lng: lot.location.lng,
    })
    dispatch(setActiveLotId(lot?.mapId))
    dispatch(setZoom(18))
    dispatch(setMarkerInfo({ ...lot, isActive: true }))
    dispatch(
      setDestination(`${lot?.address?.address1}, ${lot?.address?.cityCode}`),
    )
    datasetLayer.style = ({ feature }) =>
      setPolylineStyle({ feature, parkingLotData, filterBy: filters, lotId })
    dispatch(closeSearchBarToggle())
    if (!isDesktopView) {
      dispatch(updateBottomSheet(MOBILEPARKINGINFOWINDOW))
    }
  }
  const addToFavorite = (e) => {
    e.stopPropagation()
    setFavorited(!favorited)
    let newFavoriteList = []
    setFavorited(!favorited)
    if (favorited) {
      // If already favorited, remove
      newFavoriteList = favoritedParkingLots.filter(
        (l) => l.mapId !== lot.mapId,
      )
      // Add stop back to other list

      dispatch(
        removeParkingLotFromFavorite(
          sortListAlphabetically(newFavoriteList, 'propertyName'),
        ),
      )
    } else {
      // To do add building to list
      newFavoriteList = [...favoritedParkingLots]
      newFavoriteList.push(lot)
      dispatch(addParkingLotToFavorite(newFavoriteList))
      //   setFavorited(true)
    }
    dispatch(
      setSelectedFavoritedParkingLots(
        sortListAlphabetically(newFavoriteList, 'propertyName'),
      ),
    )
    storeFavoriteParkingLotListToFirebase(newFavoriteList.map((l) => l.mapId))
  }

  const getIconColor = (regionCode) => {
    switch (regionCode) {
      case NB:
        return { icon: faCarSide, color: NEW_BRUNSWICK_COLOR }
      case NWK:
        return { icon: faVanShuttle, color: NEWARK_COLOR }
      case CAM:
        return { icon: faTruckPickup, color: CAMDEN_COLOR }
      default:
        return { icon: faTruck, color: OTHER_COLOR }
    }
  }
  const { icon, color } = getIconColor(lot?.address?.regionCode)
  return (
    <ListItem
      button
      onClick={viewParkingLotInfo}
      key={lot.mapId}
      className={classes.list}
    >
      <ListItemIcon style={{ width: '100%', color }}>
        <FontAwesomeIcon
          icon={icon}
          style={{ paddingTop: '4px', fontSize: '1.3rem' }}
        />
        <ListItemText
          disableTypography
          primary={
            <Typography type="body2" className={classes.busStopText}>
              {lot.propertyName}
            </Typography>
          }
        />
      </ListItemIcon>
      {!isGuest ? (
        <ListItemSecondaryAction>
          <IconButton
            edge="end"
            aria-label="add/remove favorited building"
            onClick={addToFavorite}
          >
            {favorited ? (
              <FavoriteIcon className={classes.favoriteIconSelected} />
            ) : (
              <FavoriteBorderIcon className={classes.iconButtonBorder} />
            )}
          </IconButton>
        </ListItemSecondaryAction>
      ) : null}
    </ListItem>
  )
}

export default ParkingList
